import React, { Component } from "react";
import { Link } from "react-router-dom";
import facebookDeletionApi from "../services/facebookDeletionApi";
import queryString from "querystring";
import "../styles/home.css";
import "../styles/check-task.css";

export default class CheckTask extends Component {
  constructor(props) {
    super(props);
    const search = this.props.location.search;
    let taskId = null;
    if (search) {
      let params = queryString.parse(this.props.location.search);
      taskId = params.id || null;
    }
    this.state = { taskState: {}, requestFlag: false, taskId: taskId };
  }

  componentDidMount() {
    this.setRequestFlag(true);
    facebookDeletionApi
      .checkTaskState(this.state.taskId)
      .then((response) => {
        return response.status === 200 ? response.json() : null;
      })
      .then((task) => {
        this.setState({
          taskState: task || { state: "error" },
          requestFlag: false,
        });
      })
      .catch((e) => {
        this.setRequestFlag(false);
        console.log(e);
      });
  }

  setRequestFlag(flag) {
    this.setState(() => {
      return { requestFlag: flag };
    });
  }

  getStatus() {
    const state = this.state.taskState.state;
    if (state === "success") {
      return (
        <div className="check-task-card check-task-card-success">
          <span className="check-task-status-icon">OK</span>
          <p className="check-task-eyebrow">Request completed</p>
          <h1>Facebook data deleted successfully.</h1>
          <p>
            The deletion request has been processed. You can safely close this
            page or return to Lucky Spin Games.
          </p>
          <Link to="/" className="check-task-button">
            Back to Home
          </Link>
        </div>
      );
    } else if (state === "error") {
      return (
        <div className="check-task-card check-task-card-error">
          <span className="check-task-status-icon">!</span>
          <p className="check-task-eyebrow">Request failed</p>
          <h1>Facebook data deletion error.</h1>
          <p>
            We could not confirm the deletion status. Please try again later or
            contact support if the issue continues.
          </p>
          <a
            href="mailto:support@luckyspingames.com"
            className="check-task-button"
          >
            Contact Support
          </a>
        </div>
      );
    } else {
      return (
        <div className="check-task-card check-task-card-info">
          <span className="check-task-status-icon">...</span>
          <p className="check-task-eyebrow">Checking request</p>
          <h1>Checking deletion request state...</h1>
          <p>
            We are verifying the latest status of your Facebook data deletion
            request.
          </p>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="lsg-home check-task-page">
        <nav className="lsg-nav">
          <div className="lsg-container lsg-nav-inner">
            <Link to="/" className="lsg-nav-logo">
              <img
                src={`${process.env.PUBLIC_URL}/lsg-template-logo.jpg`}
                alt="Lucky Spin Games"
              />
              <div className="lsg-nav-logo-text">
                Lucky Spin Games
                <span>Game Studio</span>
              </div>
            </Link>

            <ul className="lsg-nav-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms</Link>
              </li>
            </ul>
          </div>
        </nav>

        <main className="check-task-shell">
          <div className="lsg-container">{this.getStatus()}</div>
        </main>

        <footer className="lsg-footer">
          <div className="lsg-container">
            <p className="lsg-footer-logo">Lucky Spin Games</p>
            <ul className="lsg-footer-links">
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <a href="mailto:support@luckyspingames.com">Contact Us</a>
              </li>
            </ul>
            <p className="lsg-footer-copy">
              &copy; {new Date().getFullYear()} Lucky Spin Games Inc. All
              rights reserved.
            </p>
          </div>
        </footer>
      </div>
    );
  }
}
